/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type V1ProjectsCreateProjectResponseData = {
  /**
   * The unique identifier of the newly created project, generated by Teral.
   *
   * @remarks
   * Always begins with 'proj_' followed by a unique alphanumeric sequence.
   */
  id: string;
};

/** @internal */
export const V1ProjectsCreateProjectResponseData$inboundSchema: z.ZodType<
  V1ProjectsCreateProjectResponseData,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
});

export function v1ProjectsCreateProjectResponseDataFromJSON(
  jsonString: string,
): SafeParseResult<V1ProjectsCreateProjectResponseData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      V1ProjectsCreateProjectResponseData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'V1ProjectsCreateProjectResponseData' from JSON`,
  );
}
